export const VARIABLE_PREFIXES = ["donneeAnnexe", "employee", "institution", "ligne"] as const;
export const VARIABLE_PARTS_SEPARATOR = ":";
export const LINE_COLUMNS = ["base", "taux:salarial", "taux:patronal", "montant:salarial", "montant:patronal"];
export const TABLE_FUNCTION_NAME = "table";
export const EXTERNAL_TABLE_DATE_PLACEHOLDER = "01/01/2026";
export const EXTERNAL_TABLE_QUALIFIER_PLACEHOLDER = "QUALIFIER";
export const FORMULA_IDENTIFIER_REGEX_SOURCE = "[a-zA-Z0-9._$]+";
export const FORMULA_FUNCTION_REGEX = new RegExp(`${FORMULA_IDENTIFIER_REGEX_SOURCE}(?=\\()`, "u");
export const FORMULA_IDENTIFIER_REGEX = new RegExp(FORMULA_IDENTIFIER_REGEX_SOURCE, "u");
